<template>
  <div>
    <div class="top-card">
      <div>
        <h5>当前余额（元）</h5>
        <h5>{{ balance }}</h5>
      </div>
      <div>
        <div class="mb-8" v-if="!ocrDisabled">
          OCR识别
          <el-tooltip
            class="item"
            effect="dark"
            :content="content1"
            placement="top-start"
          >
            <i class="QS-icon-question-outline"></i>
          </el-tooltip>
          <el-switch
            class="ml-16"
            v-model="ocrStatus"
            @change="handleOcrStatusChange"
          >
          </el-switch>
        </div>
        <div v-if="!ocrDisabled">
          违章识别
          <el-tooltip
            class="item"
            effect="dark"
            :content="content2"
            placement="top-start"
          >
            <i class="QS-icon-question-outline"></i>
          </el-tooltip>
          <span class="ml-16 spec" @click="handlePz">去配置</span>
        </div>
      </div>
    </div>
    <div class="section-title">交易记录</div>
    <div>
      <search-box
        :columns="layoutSearchFormItem"
        :column="3"
        @search="search"
        @btnReset="handleReset"
        :defaultValue="defaultformData"
        style="background: #fff"
      >
      </search-box>
      <div class="mid-card">
        <div>总金额(元)： {{ totalAmount }}</div>
        <div class="mid-card-export">
          <el-button
            class="ml10"
            @click="handleExport"
            :loading="loading"
            :disabled="isDisabledExport"
            type="primary"
          >
            导出明细
          </el-button>
          <el-button class="ml10" @click="handleExportList">
            导出记录
          </el-button>
        </div>
      </div>
      <QS-common-table
        class="mt16"
        :loading="tableLoading"
        :pagination="paginationData"
        :data="tableData"
        :columns="tableColumns"
        @change="paginationChange"
      ></QS-common-table>
    </div>
    <!-- 导出列表 -->
    <ExportDialogList :taskType="8" :dialogVisible.sync="dialogVisible" :tooltipStatus="false"/>
  </div>
</template>
<script>
import moment from 'moment'
import { omit, pickBy, isArray, toNumber } from 'lodash'
import ExportDialogList from '@/components/ExportDialogList/index.vue'
// eslint-disable-next-line import/no-cycle
import {
  getBalance,
  getOcrStatus,
  exportConstTradeList,
  updateOcrStatus,
  getConstTradeList,
  getCostCenterInfo,
} from '@/api/financeApi/feeCenter'
import { amoutInterval } from '@/utils/index.js'
import { layoutSearchFormItem, tableColumns } from './config'

const initDate = [
  moment()
    .subtract(29, 'days')
    .startOf('day'),
  moment().endOf('day'),
]
export default {
  name: 'CostCenter',
  components: { ExportDialogList },
  data() {
    return {
      ocrDisabled: false,
      defaultformData: {
        tradeType: '',
        tradeItems: '',
        companyName: '',
        tradeDate: initDate,
      },
      formData: {
        tradeDate: initDate,
      },
      tableData: [],
      tableColumns,
      tableLoading: false,
      balance: 0,
      content1:
        '该功能为付费功能。开启后，系统会自动识别您上传到车为家平台的证件照等信息并自动回填至文本输入框。',
      content2:
        '该功能为付费功能，开启后，系统会将定时每日自动查询违章记录，也支持手动发起违章记录查询。',
      loading: false,
      totalAmount: 0, // 总金额
      ocrStatus: false,
      dialogVisible: false,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      layoutSearchFormItem: layoutSearchFormItem.map((item) => {
        if (item.key === 'tradeDate') {
          item.options.pickerOptions = {
            // 限制只能选一年范围
            onPick: (obj) => {
              this.pickMinDate = obj.minDate
              this.pickMaxDate = obj.maxDate
            },
            disabledDate: (time) => {
              // 12个月前的第一天
              const minDate = moment()
                .subtract(12, 'months')
                .startOf('month')
                .startOf('day')
              // 今天
              const maxDate = moment().endOf('day')
              // 如果选了一个时间 限制他只能选择前后31天
              if (this.pickMinDate) {
                let beforePickMinDate = moment(this.pickMinDate)
                  .subtract(30, 'days')
                  .endOf('day')
                let afterPickMinDate = moment(this.pickMinDate)
                  .add(30, 'days')
                  .endOf('day')
                if (beforePickMinDate.isBefore(minDate)) {
                  beforePickMinDate = minDate
                }
                if (afterPickMinDate.isAfter(maxDate)) {
                  afterPickMinDate = maxDate
                }

                return (
                  moment(time).isAfter(afterPickMinDate) ||
                  moment(time).isBefore(beforePickMinDate)
                )
              }

              // return moment(time).isBetween(minDate, maxDate)
              return (
                moment(time).isAfter(maxDate) || moment(time).isBefore(minDate)
              )
            },
          }
        }
        return item
      }),
    }
  },
  computed: {
    // 是否可以导出
    isDisabledExport() {
      return this.tableData.length <= 0
    },
  },
  methods: {
    async getCostCenterInfo() {
      const { code, data } = await getCostCenterInfo()
      // "rateType": 1 // 当前的计费类型 0:"-"/1:"固定比例"/2:"固定金额",
      // "hadAmountConfig": true // 是否曾经是固定金额类型
      if (code === 1) {
        this.ocrDisabled = data.rateType === 1
      }
    },
    handlePz() {
      this.$router.push({ path: '/vehicle/violation/account' })
    },
    async handleExport() {
      this.loading = true
      try {
        const { tradeDate } = this.formData
        const params = omit(
          {
            ...this.formData,
            pageNo: this.paginationData.pageNum,
            pageSize: this.paginationData.pageSize,
          },
          'tradeDate',
        )
        // 格式化时间
        if (isArray(tradeDate) && tradeDate.length >= 2) {
          params.tradeDateStart = moment(tradeDate[0])
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss')
          params.tradeDateEnd = moment(tradeDate[1])
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss')
        }
        const { code, data } = await exportConstTradeList(pickBy({ ...params }))
        if (code === 1 && data) {
          this.$message.success(
            '所选数据已生成下载文件，请点击【导出记录】查看下载',
          )
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    async handleOcrStatusChange(status) {
      try {
        const { code } = await updateOcrStatus({ state: Number(status) })
        if (code === 1) {
          this.ocrStatus = status
          this.$message.success(`OCR识别${status ? '开启' : '关闭'}成功`)
          return
        }
        this.ocrStatus = !status
      } catch (e) {
        this.ocrStatus = !status
      }
    },
    handleExportList() {
      this.dialogVisible = true
    },
    async getBalance() {
      const { code, data } = await getBalance()
      if (code === 1) {
        this.balance = amoutInterval(toNumber(data), 4)
      }
    },
    async getOcrStatus() {
      const { code, data } = await getOcrStatus()
      if (code === 1) {
        this.ocrStatus = !!data
      }
    },
    paginationChange({ pagination }) {
      const { pageNum, pageSize } = pagination
      this.paginationData.pageNum = pageNum
      this.paginationData.pageSize = pageSize
      this.getConstTradeList()
    },
    async getConstTradeList() {
      const { tradeDate } = this.formData
      const params = omit(
        {
          ...this.formData,
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        },
        'tradeDate',
      )
      // 格式化时间
      if (isArray(tradeDate) && tradeDate.length >= 2) {
        params.tradeDateStart = moment(tradeDate[0])
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
        params.tradeDateEnd = moment(tradeDate[1])
          .endOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
      }
      this.tableData = []
      this.tableLoading = true
      const { code, data } = await getConstTradeList(pickBy({ ...params }))
      this.tableLoading = false

      if (code === 1) {
        this.tableData = data?.tradeRecordList?.items || []
        this.paginationData.total = data?.tradeRecordList?.totalNum
        this.totalAmount = amoutInterval(toNumber(data?.totalAmount), 4)
      }
    },
    handleReset() {
      this.pickMinDate = null
      this.pickMaxDate = null
      this.formData = {
        tradeDate: [
          moment()
            .subtract(30, 'days')
            .startOf('day'),
          moment().endOf('day'),
        ],
      }

      this.paginationData.pageNum = 1
      this.getConstTradeList()
    },
    search(searchData) {
      this.formData = { ...searchData }
      this.paginationData.pageNum = 1
      this.getConstTradeList()
      this.getBalance()
    },
  },
  mounted() {
    this.getCostCenterInfo()
    this.getBalance()
    this.getOcrStatus()
    this.getConstTradeList()
  },
}
</script>
<style lang="scss" scoped>
.spec{
  color: #276bec;
  cursor: pointer;
}
.top-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.section-title {
  height: 32px;
  line-height: 32px;
  border-bottom: 1px solid #ebeef5;
  position: relative;
  text-indent: 8px;
  font-size: 14px;
  font-weight: bold;
  color: #276bec;
  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    left: 0;
    height: 100%;
    background: #276bec;
    width: 2px;
  }
}
.mid-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  &-export {
    display: flex;
    flex-direction: row;
  }
}
::v-deep .el-form-item__content{
  width: 300px !important;
}
::v-deep .el-select{
  width: 100% !important;
}
::v-deep .el-date-editor{
  width: 100% !important;
}

::v-deep .search-box .column-box .el-form-item__content .el-input, .search-box .column-box .el-form-item__content .el-select, .search-box .column-box .el-form-item__content .el-textarea, .search-box .column-box .el-form-item__content .el-date-editor{
  width: 100% !important;
}
</style>
